/**
 * Section B1 Service
 * B.1.方法論引用 API 服務
 *
 * 注意: axios 攔截器會自動從 localStorage 讀取 txn_token 並添加到所有請求的 header
 * Service 層不需要手動傳遞 txn_token 參數
 */

import axios from '../api/axios';

const BASE_URL = '/api/section-b1';

// ========== Types ==========

export interface SectionB1Detail {
  id: number;
  organization_id: number;
  project_id: number;
  mothed_references: string | null;
  b_1: number;
  edit_by: number | null;
  created_at: string;
  updated_at: string | null;
}

export interface SectionB1Update {
  mothed_references?: string;
}

// ========== API ==========

/**
 * 根據專案 ID 取得 B.1 資料
 */
export const getSectionB1ByProject = async (projectId: number): Promise<SectionB1Detail | null> => {
  const response = await axios.get<SectionB1Detail>(`${BASE_URL}/by-project/${projectId}`);
  return response.data;
};

/**
 * 更新或建立 B.1 資料
 * 如果不存在會自動建立
 */
export const updateSectionB1 = async (projectId: number, data: SectionB1Update): Promise<SectionB1Detail> => {
  const response = await axios.put<SectionB1Detail>(`${BASE_URL}/${projectId}`, data);
  return response.data;
};

/**
 * 刪除 B.1 資料
 */
export const deleteSectionB1 = async (projectId: number): Promise<void> => {
  await axios.delete(`${BASE_URL}/${projectId}`);
};

const sectionB1Service = {
  getSectionB1ByProject,
  updateSectionB1,
  deleteSectionB1
};

export default sectionB1Service;
